module.exports = __webpack_public_path__ + "static/Short1-d68ed15cbf32f3a5447017a34c3925c5.png";